import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { DecimalPipe } from '@angular/common';

import { AppComponent } from './app.component';

import { ContactsModule } from './contacts/contacts.module';
import { CoreModule } from './core/core.module';
import { BasicsModule } from './basics/basics.module';

import { HttpRepositoryService } from './core/http-repository.service';
import { AntiForgeryTokenService } from './auth/anti-forgery-token.service';
import { UserProfileService } from './user-profile/user-profile.service';
import { UserCompanyService } from './nav-menu/user-company.service';
import { CompanyService } from './companies/company-edit/company.service';
import { NavModule } from './nav-menu/nav.module';
import { CampaignsModule } from './campaigns/campaigns.module';
import { CompaniesModule } from './companies/companies.module';
import { AdminModule } from './admin/admin.module';
import { AuthModule } from './auth/auth.module';
import { UserProfileModule } from './user-profile/user-profile.module';
import { ChartsModule } from 'ng2-charts';
import { ReportsModule } from './reports/reports.module';
import { SelectDateService } from './reports/cumulative-campaign-statistics/select-date.service';




@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,    
    NavModule,
    ContactsModule,
    BasicsModule,
    CoreModule,
    CampaignsModule,
    FormsModule,
    ReactiveFormsModule,
    CompaniesModule,
    AdminModule,
    AuthModule,
    UserProfileModule,
    ReportsModule,
    ChartsModule
  ],
  providers: [
    DecimalPipe,
    HttpRepositoryService,
    AntiForgeryTokenService,
    UserProfileService,
    UserCompanyService,
    CompanyService,
    SelectDateService
  ],
  bootstrap: [AppComponent],
  entryComponents: []
})
export class AppModule { }

